<template>
  <div
    class="my-card"
    :style="{ backgroundImage: `url(${bgUrl})` }"
    @click="handleClick"
    :class="{ disabled: !clickable }"
  >
    <div class="top">
      <div class="tag">Gift Card</div>
    </div>
    <div class="number-row">
      <div class="number">{{ displayNumber }}</div>
      <div class="copy" @click.stop="copyNumber" aria-label="Copy Card Number">
        <img :src="copyIcon" alt="Copy" class="copy-icon" />
      </div>
    </div>
    <div class="store">{{ card.storeName }}</div>
    <div class="address">{{ card.address }}</div>
    <div class="bottom">
      <div class="label">Balance</div>
      <div class="amount">{{ amountText }}</div>
    </div>
  </div>
  </template>
<script>
import { Toast } from 'vant'
export default {
  name: 'MyGiftCard',
  props: {
    card: {
      type: Object,
      default: () => ({
        id: '',
        number: '',
        storeName: '',
        address: '',
        amount: 0,
        bg: 1
      })
    },
    clickable: { type: Boolean, default: true }
  },
  computed: {
    copyIcon() {
      return require('@/assets/giftCard/copy.svg')
    },
    bgUrl() {
      // 优先使用 cardImage 或 card_image 字段
      const cardImage = this.card.cardImage || this.card.card_image
      if (cardImage) {
        const url = this.formatImagePath(cardImage)
        return url || require('@/assets/giftCard/card1.png')
      }
      const idx = this.card.bg || 1
      try {
        return require(`@/assets/giftCard/card${idx}.png`)
      } catch (e) {
        return require('@/assets/giftCard/card1.png')
      }
    },
    displayNumber() {
      // group number as "8455 5689 8971 8779"
      const n = (this.card.number || '').replace(/\s+/g, '')
      return n.replace(/(\d{4})(?=\d)/g, '$1 ').trim()
    },
    amountText() {
      const amt = Number(this.card.amount || 0).toFixed(2)
      return `$${amt}`
    }
  },
  methods: {
    formatImagePath(path) {
      if (!path) return ''
      let finalPath = path.trim()
      if (/^https?:/i.test(finalPath)) {
        return finalPath.replace('http://localhost:8080', 'http://www.hwm.red')
      }
      finalPath = finalPath.replace(/^\/+/, '')
      // 相对路径需要加上 /uploads/ 前缀（参考网页端的 resolveUploadUrl）
      const fullPath = finalPath.startsWith('uploads/') ? `/${finalPath}` : `/uploads/${finalPath}`
      return `http://www.hwm.red${fullPath}`
    },
    handleClick() {
      if (!this.clickable) return
      const targetId = this.card.detailId || this.card.id
      this.$router.push({
        path: '/myGiftCardDetail',
        query: {
          id: targetId,
          binding_id: this.card.id || '',
          card_no: this.card.number || '',
          bg: this.card.bg || 1,
          balance: this.card.amount || 0
        }
      })
    },
    copyNumber() {
      const text = this.card.number || ''
      if (!text) return
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          Toast && Toast('Card number copied')
        })
      } else {
        // 兼容写法
        const input = document.createElement('input')
        input.value = text
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
        Toast && Toast('Card number copied')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.my-card {
  position: relative;
  width: 100%;
  border-radius: 12px;
  background: linear-gradient(135deg, #1a3a2f 0%, #0d2920 50%, #1a3a2f 100%);
  background-size: cover;
  background-repeat: no-repeat;
  padding: 1rem 1.25rem 1.25rem;
  box-sizing: border-box;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 0.75rem;
  overflow: hidden;
  // 发光效果
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 30%;
    width: 150px;
    height: 150px;
    background: radial-gradient(circle, rgba(100, 180, 140, 0.35) 0%, transparent 70%);
    transform: translate(-50%, -50%);
    pointer-events: none;
  }
    .top {
      position: relative;
      z-index: 1;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 8px;
      .tag {
        color: #fff;
        font-weight: 500;
        font-size: 0.75rem;
      }
    }
  .number-row {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
    .copy {
      width: 32px;
      height: 32px;
      border-radius: 6px;
      background: transparent;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      transition: transform 0.2s ease;
      &:active {
        transform: scale(1.1);
      }
      .copy-icon {
        width: 24px;
        height: 24px;
      }
    }
  }
  .number {
    position: relative;
    z-index: 1;
    font-size: 1.125rem;
    font-weight: 600;
    letter-spacing: 2px;
    flex: 1;
  }
  .store {
    position: relative;
    z-index: 1;
    font-size: 0.875rem;
    font-weight: 500;
    margin-bottom: 2px;
  }
  .address {
    position: relative;
    z-index: 1;
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.6);
    margin-bottom: 12px;
  }
    .bottom {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .label {
        font-size: 0.75rem;
        color: #fff;
      }
      .amount {
        font-size: 1.25rem;
        font-weight: 700;
      }
  }
}
.disabled {
  /* 不屏蔽子元素点击，靠方法内的 clickable 判断拦截卡片跳转 */
}
</style>
